import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import Layout from '../../App/layout'
import LayoutContentWrapper from '../../../components/utility/layoutWrapper'
import ContentLayout from '../../../components/utility/layoutContent'
import { AccountingsContainer } from './AccountingsContainer'

const OrderAccountingsPage = ({ match }) => {
    const { id } = match.params

    useEffect(() => {
        document.title = `${id} | OSH CRM`
    }, [id])

    return (
        <Layout>
            <LayoutContentWrapper breadcrumbs={
                [
                    { path: `/order_summaries`, name: 'Orders' },
                    { path: `/inquiries/${id}`, name: id },
                    { path: `/orders/${id}/accountings`, name: 'Accountings' }
                ]
            }>
                <ContentLayout>
                    <AccountingsContainer orderId={id} />
                </ContentLayout>
            </LayoutContentWrapper>
        </Layout>
    )
}

OrderAccountingsPage.propTypes = {
    match: PropTypes.object.isRequired
}

export default OrderAccountingsPage
